import React from "react";

import WPButton from "../../packages/WPButton";

import { combineClassNames } from "../../utils/appUtils";

import "./index.css";

/**
 * Tertiary button with dynamic icon and size
 * @param {object} props
 * @param {string} props.id
 * @param {string} props.label
 * @param {function} props.onClick
 * @param {boolean} [props.disabled]
 * @param {React.ReactNode} [props.icon] - Icon component to render
 * @param {string} [props.size] - Button size: 'small', 'medium', 'large'
 * @param {number} [props.tabIndex]
 * @param {string} [props.className] - Additional class names
 * @param {string} [props.variant] - Button variant: 'text', 'contained', 'outlined'
 * @param {string} [props.type] - Button type: 'primary', 'secondary', 'warning', 'danger'.
 * @param {('before'|'after')} [props.iconPlacement] - Icon position relative to label
 * @param {string} [props.tooltip] - Tooltip text for button
 * @param {string} [props.tooltipPlacement] - Tooltip placement
 */

const WPTertiaryButton = ({
  id,
  label,
  onClick,
  disabled,
  icon,
  size,
  tabIndex,
  className,
  preventDefault,
  variant = "text",
  type = "primary",
  iconPlacement = "after",
  tooltip,
  tooltipPlacement = "top",
}) => {
  return (
    <WPButton
      id={id}
      size={size}
      disabled={disabled}
      onClick={onClick}
      preventDefault={preventDefault}
      variant={variant}
      type={type}
      tooltip={tooltip}
      tooltipPlacement={tooltipPlacement}
      customClass={combineClassNames("wp-tertiary-button", className)}
      tabIndex={tabIndex}
    >
      {icon && iconPlacement === "before" && (
        <span className="tertiary-btn-icon-wrapper">{icon}</span>
      )}
      {label}
      {icon && iconPlacement === "after" && (
        <span className="tertiary-btn-icon-wrapper">{icon}</span>
      )}
    </WPButton>
  );
};

export default WPTertiaryButton;
